import { all, call, fork, put, cancel, take } from 'redux-saga/effects';

import * as reportActions from 'actions/report';
import * as reportApi from 'api/Report';

import { showErrorNotification } from 'actions/App';

import {
  GET_REPORT_PENDING,
  CANCEL_REPORT,
  GET_REPORT_FINISH,
  GET_HISTORY_REPORT_LIST,
} from 'constants/ActionTypes';

function* generateReport({ payload }) {
  const { filters, fileName, reportType, source = 'routes' } = payload;
  try {
    // Choose API based on source: 'routes' for transportation, 'eca' for ECA history
    const apiCall = source === 'eca'
      ? reportApi.getEcaHistoryReportByTypeApi
      : reportApi.getHistoryReportByTypeApi;

    const response = yield call(apiCall, reportType, {
      filters,
      fileName,
    });

    const url = window.URL.createObjectURL(
      new Blob([response], { type: 'application/vnd.ms-excel' }),
    );
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    yield put(reportActions.getReportSuccess());
  } catch (error) {
    if (error && error.status === 409) {
      yield put(reportActions.showInQueueNotification());
    } else {
      yield put(showErrorNotification(error.messages));
      yield put(reportActions.getReportError());
    }
  } finally {
    yield put(reportActions.getReportFinish());
  }
}

function* generateReportSaga() {
  while (true) {
    const generateReportAction = yield take(GET_REPORT_PENDING);
    const getReportTask = yield fork(generateReport, generateReportAction);
    const cancelAction = yield take([CANCEL_REPORT, GET_REPORT_FINISH]);

    if (cancelAction.type === CANCEL_REPORT) {
      yield cancel(getReportTask);
    }
  }
}

function* getHistoryReportsList() {
  try {
    const response = yield call(reportApi.getHistoryReportsListApi);
    yield put(reportActions.getHistoryReportsListSuccess(response.data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* getHistoryReportsListSaga() {
  yield take(GET_HISTORY_REPORT_LIST);
  yield call(getHistoryReportsList);
}

const rootSaga = function* saga() {
  yield all([generateReportSaga, getHistoryReportsListSaga].map(fork));
};

export default rootSaga;
